import { styled } from '@mui/material';
import { JsonInput } from 'shared/react-admin/Inputs/JsonInputIntrospected/JsonInput';

export const JsonInputStyled = styled(JsonInput)({
  flex: 1,
  marginBottom: 0,
  '& .jer-editor-container': {
    background: '#fff !important',
    border: '1px solid #c4c4c4',
    maxWidth: 'none !important',
    height: '100%',
  },
});
